/** ນາທີຕາມเข็มເວລາ: ມີແຕ່ 00 / 15 / 30 / 45 */

export const QUARTER_CLOCK_MINUTES = [0, 15, 30, 45] as const;
export type QuarterClockMinute = (typeof QUARTER_CLOCK_MINUTES)[number];

export function snapMinuteToQuarter(min: number): QuarterClockMinute {
  const x = ((min % 60) + 60) % 60;
  let best: QuarterClockMinute = 0;
  let dist = 99;
  for (const q of QUARTER_CLOCK_MINUTES) {
    const d = Math.abs(q - x);
    if (d < dist) {
      dist = d;
      best = q;
    }
  }
  return best;
}

/**
 * แปลง "HH:mm" หรือ "HH:mm:ss" → ชั่วโมงกับนาทีควอเตอร์
 */
export function parseQuarterClock(s: string): {
  h: number;
  m: QuarterClockMinute;
} {
  const raw = (s || "09:00").trim();
  const [hs, ...rest] = raw.split(":");
  const mi = rest.join(":"); // "30" or "30:00"
  const hi = Number.parseInt(hs ?? "9", 10);
  const h = Number.isNaN(hi) ? 9 : Math.min(23, Math.max(0, hi));
  const minutePart = mi.slice(0, 2);
  const mit = Number.parseInt(minutePart || "0", 10);
  const mm = Number.isNaN(mit) ? 0 : mit;
  return { h, m: snapMinuteToQuarter(mm) };
}

export function formatQuarterHhMm(h: number, m: QuarterClockMinute): string {
  return `${String(Math.min(23, Math.max(0, h))).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

/** ค่าที่เก็บตรงกับชั่วโมง+นาทีควอเตอร์ (รับทั้ง HH:mm และ HH:mm:ss) */
export function isCanonicalQuarterHhMm(s: string): boolean {
  const t = (s || "").trim();
  if (!t) return false;
  const normalized = t.length >= 8 ? t.slice(0, 5) : t;
  const { h, m } = parseQuarterClock(normalized);
  return formatQuarterHhMm(h, m) === normalized;
}

export const QUARTER_CLOCK_HOUR_OPTIONS = Array.from(
  { length: 24 },
  (_, i) => ({
    value: String(i),
    label: String(i).padStart(2, "0"),
  }),
);

export const QUARTER_CLOCK_MINUTE_OPTIONS = QUARTER_CLOCK_MINUTES.map((n) => ({
  value: String(n),
  label: String(n).padStart(2, "0"),
}));
